import { render, staticRenderFns } from "./ManageUserNotifications.vue?vue&type=template&id=25fda282&"
import script from "./ManageUserNotifications.vue?vue&type=script&lang=js&"
export * from "./ManageUserNotifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports